import { Component, Injector, OnInit } from '@angular/core';
import { TableColumn } from '../../../shared/models/table.model';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AccessString } from '../../../auth/enums/access-string.enum';
import { AccessType } from '../../../auth/enums/access-type.enum';
import { ActionString } from '../../../auth/enums/action-string.const';
import { BaseComponent } from '../../../shared/class/base-component.class';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { Organization } from '../../../shared/models/Organization.model';
import { MessageType } from '../../../shared/enums/message-type.enum';
import { BaseFormComponent } from '../../../shared/class/base-form.class';
import { FormControl } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-view-org',
  templateUrl: './view-org.component.html',
  styleUrl: './view-org.component.scss'
})
export class ViewOrgComponent extends BaseFormComponent implements OnInit {
  orgData: Organization | undefined;
  subscriptionDurationOptions = ['3m', '6m', '1y', '2y'];
  subscriptionTiers = ['FREE', 'BASIC', 'PREMIUM', 'ENTERPRISE'];
  filteredSubscriptions: string[] = this.subscriptionTiers;
  filteredDurations: string[] = this.subscriptionDurationOptions;
  today: Date = new Date();

  ngOnInit(): void {
    const orgId = this.route.snapshot.params['id'];
    this.getOrganization(orgId);
  }


  addSubscriptionForm = this.fb.group({
    tier: new FormControl(''),
    duration: new FormControl(''),
    id: new FormControl<number | undefined>(undefined)
  })

  async getOrganization(orgId: number) {
    try {
      let response:ApiResponse<any> = await this.httpService.httpRequest<Organization>(
        "organization",
        `get-by-admin`,
        {
          id: orgId,
          relations: 'users,subscriptions'
        }
       );
      if (response.status) {
        this.orgData = response.data!;
        return;
      }
    } catch (e) {
      this.notificationService.notify('Unable to get Organization Data', MessageType.Error)
    }
  }


  filterSubscription(event: AutoCompleteCompleteEvent) {
    let query = event.query.toLowerCase();
    this.filteredSubscriptions = this.subscriptionTiers.filter(tier =>
        tier.toLowerCase().includes(query)     );
  }

  filterDuration(event: AutoCompleteCompleteEvent) {
    let query = event.query.toLowerCase(); // Get the query typed by the user
    this.filteredDurations = this.subscriptionDurationOptions.filter(duration =>
        duration.toLowerCase().includes(query) // Filter durations based on the query
    );
}


isAddSubscriptionPopupVisible: boolean = false;

addSubscriptionPopup() {
  this.isAddSubscriptionPopupVisible = true;
}

async addSubscription(): Promise<void> {
  if (this.addSubscriptionForm.invalid) {
    this.notificationService.showError("Please fill all required fields correctly.");
    return;
  }

  try {
    let payload = this.addSubscriptionForm.value;

    payload = {
      ...payload,
      id: this.orgData?.id
    };

    const response: ApiResponse<any> = await this.httpService.httpRequest<any>(
      "organization",
      "update-subscription",
      payload
    );

    if (response.status && response.data) {
      this.notificationService.showSuccess("Subscription Added Successfully");
      this.addSubscriptionForm.reset();
      this.isAddSubscriptionPopupVisible = false;
      this.router.navigateByUrl("/settings/org");
    } else {
      this.notificationService.showError('Failed to update subscription');
    }
  } catch (error) {
    this.notificationService.showError("An error occurred while updating the subscription");
  }
}
}
